import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'

const getResourceRequestData = async <T>(url: string) => {
  const response = await monolithHttpClient.get<T>(
    `/automation/resources${url}`,
  )
  return response.data
}

export type TagsResourcesResponseType = Array<{
  id: number
  name: string
}>

export const getTagsResources = () =>
  getResourceRequestData<TagsResourcesResponseType>('/tags')

export type CoursesResourcesResponseType = Array<{
  id: number
  name: string
}>

export const getCoursesResources = () =>
  getResourceRequestData<CoursesResourcesResponseType>('/courses')

export type EmailsResourcesResponseType = Array<{
  id: number
  subject: string
}>

export const getEmailsResources = () =>
  getResourceRequestData<EmailsResourcesResponseType>('/emails')

export type SpecificEmailsResourcesResponseType = Array<{
  id: number
  subject: string
}>

export const getSpecificEmailsResources = () =>
  getResourceRequestData<SpecificEmailsResourcesResponseType>(
    '/specific-emails',
  )

export type CampaignsResourcesResponseType = Array<{
  id: number
  name: string
}>

export const getCampaignsResources = () =>
  getResourceRequestData<CampaignsResourcesResponseType>('/campaigns')

export type CommunitiesResourcesResponseType = Array<{
  id: number
  name: string
}>

export const getCommunitiesResources = () =>
  getResourceRequestData<CommunitiesResourcesResponseType>('/communities')

export type CoursesBundlesResourcesResponseType = Array<{
  id: number
  name: string
  createdAt: {
    date: string
    timezone_type: number
    timezone: string
  }
  removedAt: string | null
  deactivatedAt: string | null
  description: string | null
  instructorName: string | null
}>

export const getCourseBundlesResources = () =>
  getResourceRequestData<CoursesBundlesResourcesResponseType>('/course-bundles')
